export default __webpack_public_path__ + "static/amsterdamUMC-19b905e0400aca16a2c579612e25f465.png";